export default __webpack_public_path__ + "static/media/man.558f6f32.png";